import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { type FC } from 'react';

import type { Props as RichTextProps } from 'src/components/common/rich-text/rich-text-renderer';
import { media } from 'src/styles';
import { EntryHeader } from '../entry-header';
import { Content as ArchiveContent } from './archive';
import type { Props as ContentProps } from './common/content';
import { Content as SingleContent } from './single';

type Props = Omit<ContentProps, 'imageAlt'> & {
  className?: string;
  postType?: 'news' | 'gallery' | 'shop' | 'interior' | 'sakamoto-yaeca';
  name?: string;
  isSingle?: boolean;
  title?: string | null;
  date?: string | null;
  category?: string | null;
  to?: string;
  content?: RichTextProps['document'] | null;
};

export const Entry: FC<Props> = ({
  postType,
  className,
  name,
  isSingle = true,
  title,
  date,
  category,
  to,
  ...contentProps
}) => {
  return (
    <Wrapper
      id={name ?? ''}
      className={className ?? ''}
      as={isSingle ? 'div' : 'article'}
    >
      <EntryHeader
        isSingle={isSingle}
        title={title}
        meta={{ date, category }}
        to={to}
      />
      {(contentProps.content || contentProps.meta) && (
        <>
          {isSingle && (
            <StyledSingleContent imageAlt={title} {...contentProps} />
          )}
          {!isSingle && (
            <StyledArchiveContent
              imageAlt={title}
              isDefaultHideContent={
                postType === 'gallery' || postType === 'interior'
              }
              {...contentProps}
            />
          )}
        </>
      )}
    </Wrapper>
  );
};

const ContentStyle = css`
  margin-top: 1.2em;
  ${media.greaterThanSiteBreakpoint} {
    margin-top: 60px;
  }
`;

const StyledSingleContent = styled(SingleContent)`
  ${ContentStyle}
`;

const StyledArchiveContent = styled(ArchiveContent)`
  ${ContentStyle}
`;

const Wrapper = styled.div``;

export default Entry;
